import React from 'react';
import classNames from 'classnames';
import BoringAvatar from 'boring-avatars';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import styles from './Avatars.module.scss';

export function Avatar({
  url,
  size = null,
  initials = null,
  placeholder = null,
  name = null,
  square = false,
  bgGlow = false,
  ...props
}) {
  const { grayscale, ...additionalProps } = props;
  additionalProps.className = classNames(
    'avatar',
    props.className,
    size && `avatar-${size}`,
    grayscale && 'grayscale',
  );

  let img = <span {...additionalProps} style={{ backgroundImage: `url(${url})` }} />;

  if (!url) {
    img = (
      <span {...additionalProps}>
        <SwitchTransition mode="in-out">
          <CSSTransition
            key={name}
            // this is due to an issue with the types, but below follows documentation
            // @ts-ignore
            addEndListener={(node, done) => node.addEventListener('transitionend', done, false)}
            classNames="fade"
          >
            <span className="avatar-placeholder">
              <BoringAvatar
                size={10}
                square={square}
                name={name || ''}
                variant="marble"
                colors={[
                  'rgba(74,144,226,0.8)',
                  'rgba(76,198,215,0.8)',
                  'rgba(201,135,229,0.8)',
                  'rgba(74,144,226,0.8)',
                  'rgba(255,183,74,0.8)',
                  'rgba(143,198,96,0.8)',
                ]}
              />
              {!initials ? null : <span className="avatar-placeholder-text">{initials}</span>}
            </span>
          </CSSTransition>
        </SwitchTransition>
      </span>
    );
  }

  if (!bgGlow) {
    return img;
  } else {
    let blurImg = null;

    if (!url) {
      blurImg = img;
    }

    return (
      <div className="avatar-container">
        <span
          className={classNames('avatar-blur', size)}
          style={url ? { backgroundImage: `url(${url})` } : {}}
        >
          {blurImg}
        </span>
        {img}
      </div>
    );
  }
}

export function ContactAvatar({ contact, ...props }) {
  if (!contact) {
    return null;
  }

  const name = contact.displayName || contact.display_name || contact.firstName || '';
  let initial = (name[0] || '').toUpperCase();

  return (
    <Avatar
      {...props}
      url={contact.avatarURL || contact.avatar_url}
      initials={initial}
      name={name}
      grayscale={contact.isMemorialized || props.grayscale}
    />
  );
}

export function ContactAvatarGroup({ contacts, displayCount = 2 }) {
  return (
    <div className={styles.avatarGroup}>
      {contacts
        .slice(0, displayCount)
        .reverse()
        .map((contact) => (
          <div className={styles.avatarGroupMember} key={contact.id}>
            <ContactAvatar contact={contact} size="sm" />
          </div>
        ))}
    </div>
  );
}
